export default __webpack_public_path__ + "static/media/roadmap3.99708b6d.png";